<template>
  <v-container fluid grid-list-md>
    <v-card style="padding: 16px; border-radius: 16px" class="mx-auto elevation-2">
      <v-card-text class="headline font-weight-bold">
        <v-card-actions class="headline font-weight-bold">
          <h3>Estabelecimentos</h3>
          <v-spacer></v-spacer>
        </v-card-actions>
        <div style="font-size: 16px; font-weight: 400">
          <i>Utilize os Filtros para melhorar a sua busca.</i>
        </div>

        <v-btn v-show="isLoad" color="blue darken-1" text>
          Processando...
          <v-progress-circular
            indeterminate
            color="white"
          ></v-progress-circular>
        </v-btn>

        <v-layout align-center justify-end>
          <v-btn color="primary" fab top right small @click="enableNew">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn fab top right small @click="enableFilters">
            <v-icon>filter_list</v-icon>
          </v-btn>
          <!-- <export /> -->
        </v-layout>
      </v-card-text>
    </v-card>

    <v-layout row wrap style="margin: 0.5rem 0">
      <v-flex xs12 md4>
        <v-card class="ma-2 summary-card" color="#3e9c35" dark>
          <v-card-text>
            <div class="caption">Transacionado no mês</div>
            <div class="headline">{{ $n(summary.month_transacted, "currency") }}</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md4>
        <v-card class="ma-2 summary-card" color="#607D8B" dark>
          <v-card-text>
            <div class="caption">Máquinas</div>
            <div class="headline">{{ summary.devices_count }}</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md4>
        <v-card class="ma-2 summary-card" color="#9E9E9E" dark>
          <v-card-text>
            <div class="caption">Comissão</div>
            <div class="headline">Em breve</div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-tabs v-model="activeTab" grow class="partners-tabs" style="margin-top: 8px">
      <v-tabs-slider></v-tabs-slider>
      <v-tab>Estabelecimentos</v-tab>
      <v-tab>Perfil de Taxas</v-tab>
      <v-tab>Comissões</v-tab>

      <v-tab-item>
        <filters />
        <list />
        <modal-new />
      </v-tab-item>
      <v-tab-item>
        <rate-profile />
      </v-tab-item>
      <v-tab-item>
        <commissions />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "partners",
  created() {
    this.$store.dispatch("account/getAccount");
    this.$store.dispatch("partners/loadSummary");
  },
  components: {
    List: () => import("@/components/desktop/partners/List.vue"),
    ModalNew: () => import("@/components/desktop/partners/ModalNew.vue"),
    Filters: () => import("@/components/desktop/partners/Filters.vue"),
    RateProfile: () => import("@/components/desktop/partners/RateProfile.vue"),
    Commissions: () => import("@/components/desktop/partners/Commissions.vue"),
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    ...mapGetters({
      isLoad: "partners/isLoad",
      color: "account/color",
      showFilters: "partners/showFilters",
      summary: "partners/summary",
    }),
  },
  watch: {
    isLoad(newValue) {
      if (newValue) {
        this.isLoad = newValue;
      }
    },
    showFilters(newValue) {
      if (newValue) {
        this.showFilters = newValue;
      }
    },
  },
  methods: {
    enableNew() {
      this.$store.dispatch("partners/activeNew", true);
    },
    enableFilters() {
      this.$store.dispatch("partners/showFilters", true);
    },
  },
};
</script>

<style>
  .summary-card {
    border-radius: 16px !important;
  }

  .partners-tabs .v-tabs__bar {
    border-radius: 14px 14px 0 0;
  }

  .partners-tabs .v-tabs__items,
  .partners-tabs .v-window {
    border-radius: 0 0 14px 14px;
  }
</style>
